import apiClient from '../api/base/apiClient'

/**
 * 안드로이드 설치 경로를 서버에 한 번 올린다.
 *
 * 어디서 오나
 * ----------
 * download.html이 스토어로 보낼 때 referrer에 utm 값을 심는다 →
 * 플레이스토어가 설치할 때 보관한다 → 앱이 읽어서 웹뷰에 넣어준다
 * (`FlutterBridge.installReferrer`) → 여기서 서버로 올린다.
 *
 * 이 값이 있어야 "카카오로 100번 눌렀고 그중 25명이 가입해 8명이 남았다"를
 * 볼 수 있다. 지금은 클릭까지만 세고 그 뒤가 끊긴다.
 *
 * 왜 로그인 뒤인가
 * --------------
 * 계정에 붙이는 값이라 누구인지 알아야 한다. 설치 직후 아직 가입 전이면
 * 올릴 곳이 없다. 앱이 이 값을 계속 들고 있으므로 로그인한 뒤에 올리면 된다.
 *
 * 한 번만 보낸다
 * -------------
 * 서버도 처음 받은 것만 남기지만, 매번 요청을 날릴 이유가 없으므로 이 기기에서
 * 보냈다는 표시를 남긴다. iOS·웹 브라우저에는 값 자체가 없어 그냥 지나간다.
 */
const SENT_KEY = 'install_referrer_sent'

export async function reportInstallReferrer(): Promise<void> {
  let referrer = ''
  try {
    referrer = String(
      (window as unknown as { FlutterBridge?: { installReferrer?: string } })
        .FlutterBridge?.installReferrer ?? ''
    )
  } catch {
    return
  }

  if (!referrer) return

  try {
    if (localStorage.getItem(SENT_KEY) === referrer) return
  } catch {
    // 저장소를 못 쓰는 환경이면 그냥 보낸다. 서버가 중복을 걸러준다
  }

  try {
    await apiClient.post('/user/install-referrer', { referrer })
    try {
      localStorage.setItem(SENT_KEY, referrer)
    } catch {
      // 위와 같은 이유
    }
  } catch {
    // 설치 경로는 있으면 좋은 정보다. 실패해도 사용자에게 알리지 않는다.
    // 다음 실행 때 다시 시도한다.
  }
}
